
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Products } from "@components/products";
import { PvcWindowContent } from "@components/pvc-window-content";
import { ROLLERS } from "@consts/rrollers";
import type { IProduct } from "@type/products";
import { getAllRollersByParent, getAllRollersPathsById, getRollerById, } from "@utils/get-products";
import type { GetStaticPaths, GetStaticProps, NextPage } from "next/types";
interface IProductCard {
    product: IProduct;
    products: IProduct[];
}
const TestCenter: NextPage<IProductCard> = ({ product, products }) => (<div className="bg-white">
    <div className="mx-auto max-w-7xl px-4 py-2 text-center sm:px-6 lg:px-8">
      <PvcWindowContent product={product}/>
      {products && <Products productPage products={products} showId/>}
    </div>
  </div>);
export const getStaticPaths: GetStaticPaths = async () => {
    const PATHS_IDS = Object.values(ROLLERS.BLINDS);
    const { paths: path } = await getAllRollersPathsById(PATHS_IDS);
    const paths = path.map((p: {
        slug: string;
        databaseId: string;
        language: {
            code: string;
        };
    }) => ({
        locale: p.language.code.toLowerCase(),
        params: {
            slug: `${p.slug}-${p.databaseId}`,
        },
    }));
    return {
        fallback: "blocking",
        paths,
    };
};
const getStaticProps: GetStaticProps = async (context) => {
    const slug = context.params?.slug as string;
    const locale = context.locale ?? "pl";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const PRODUCT_ID = slug.split("-").pop();
    const { product } = await getRollerById(PRODUCT_ID);
    if (!product) {
        return { notFound: true };
    }
    const { products } = await getAllRollersByParent(ROLLERS.BLINDS[LOCALE as keyof typeof ROLLERS.BLINDS], LOCALE);
    return {
        props: {
            product,
            products,
        },
    };
};
export default TestCenter;

    async function __Next_Translate__getStaticProps__1a19cd2c0c3__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/rollers/blinds/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2c0c3__ as getStaticProps }
  